import { Vue, prop } from 'vue-class-component';
import { WidgetWrapper } from '@/components/widget-wrapper';
import firstUp from 'lodash/upperFirst';
import { TileSelector } from '@/components/tile-selector';
import { CompareDataObject, DealType } from '@/types/writeup';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import styles from './styles.module.scss';

class LengthSelectorProps {
	type = prop<DealType>({ default: undefined })

	compareData = prop<CompareDataObject[]>({ default: undefined })

	active = prop<string>({ default: undefined })

	loading = prop<boolean>({ default: true })

	onChange = prop<Function>({ default: () => () => undefined })
}

export class LengthSelector extends Vue.with(LengthSelectorProps) {
	@Inject() readonly i18n!: VueI18n;

	get tiles() {
		if (this.type === DealType.loan) {
			return (this.compareData && this.compareData[0] && this.compareData[0].terms) ? this.compareData[0]?.terms.map(term => ({
				id: String(term.termLength),
				title: String(this.i18n.t('lengthSelector.monthValue', { count: term.termLength }))
					.concat(' | ')
					.concat(this.i18n.t('lengthSelector.aprValue', { apr: term.apr })),
				description: String(term.lenderName),
			})) : [];
		}
		if (this.type === DealType.lease) {
			return (this.compareData && this.compareData[0] && this.compareData[0].terms) ? this.compareData[0]?.terms.map(term => ({
				id: String(term.termLength),
				title: this.i18n.t('lengthSelector.monthValue', { count: term.termLength }),
				description: this.i18n.t('lengthSelector.yearValue', { count: Math.round(term.termLength / 12 * 10) / 10 }),
			})) : [];
		}
		return [];
	}

	render() {
		return (
			<WidgetWrapper
				class={ styles.lengthSelector }
				title={ this.type ? this.i18n.t(`lengthSelector.configure${firstUp(this.type)}`) : undefined }
				active={ !!this.active || this.loading }
				loading={ this.loading }
			>
				<TileSelector v-show={ this.type === DealType.loan } style={ '--skeleton-height: 22px; --skeleton-width: 6em;--skeleton-font-size: 10px;'}
					tiles={ this.tiles }
					active={ String(this.active) }
					onChange={ this.onChange }
					fullWidth
				/>

				<TileSelector v-show={ this.type === DealType.lease } style={ '--skeleton-height: 22px; --skeleton-width: 6em;--skeleton-font-size: 10px;'}
					tiles={ this.tiles }
					active={ String(this.active) }
					onChange={ this.onChange }
				/>
			</WidgetWrapper>
		);
	}
}
